
import { OperationCategoryEnum, PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('dc')
export class DcEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 15,
        name: 'dc_no'
    })
    dcNo: string;

    @Column('int', {
        nullable: false,
        name: 'dc_quantity'
    })
    dcQuantity: number;

    @Column('date', {
        nullable: false,
        name: 'dc_date'
    })
    dcDate: string;

    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;
}

